import { z } from 'zod';
import { defineEndpoint } from '../define';
import { VersionStringSchema } from '../release-products/shapes';
import { ReleaseDetailSchema } from './shapes';

/** Full-replace of a draft's cross-product requirements. Drafts only. */
export const PutReleaseRequirementsBodySchema = z.object({
  items: z.array(
    z.object({
      productId: z.string().uuid(),
      version: VersionStringSchema,
    }),
  ),
});
export type PutReleaseRequirementsBody = z.infer<typeof PutReleaseRequirementsBodySchema>;

export const putReleaseRequirements = defineEndpoint({
  method: 'PATCH',
  path: '/v1/releases/:releaseId/requirements',
  params: z.object({ releaseId: z.string().uuid() }),
  query: z.object({}),
  body: PutReleaseRequirementsBodySchema,
  response: z.object({ data: ReleaseDetailSchema }),
});
